// extracted by mini-css-extract-plugin
export default {"inputFile":"InputDocFileUI_inputFile__vMu5b","imageContainer":"InputDocFileUI_imageContainer__4T0W4","imgItem":"InputDocFileUI_imgItem__7loRv","img":"InputDocFileUI_img__KGuwN"};